var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 27,
    viewBox: "0 0 10 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75086 11.8399C3.47653 11.9084 3.27078 11.9313 3.11075 11.9999C2.81356 12.1142 2.56209 12.2513 2.2649 12.3885C2.10487 12.4571 1.94485 12.5485 1.78482 12.5943C1.30474 12.7314 0.618917 12.5028 0.458891 12.1599C0.298865 11.817 0.504613 11.2912 0.916109 10.9483C2.47065 9.64521 4.16235 8.54789 6.19697 8.11353C6.72277 7.99923 7.29429 7.93064 7.82009 7.90778C9.1003 7.86206 9.85471 8.84508 9.48894 10.1024C8.41447 13.7373 7.36288 17.3722 6.31128 21.0071C6.21983 21.2814 6.17411 21.5786 6.08267 21.9672C6.357 21.8986 6.53988 21.8758 6.69991 21.7843C7.29429 21.4871 7.86581 21.1671 8.4602 20.8928C9.07744 20.5956 9.64896 20.8242 9.90043 21.4186C10.0605 21.7843 9.99187 22.1272 9.67182 22.3787C7.88867 23.6818 6.08267 24.9849 3.93374 25.6707C3.45367 25.8307 2.95073 25.9679 2.47065 26.0136C0.778943 26.1965 -0.204075 24.962 0.276004 23.316C1.00755 20.8928 1.76196 18.4695 2.51637 16.0234C2.85928 14.8804 3.22506 13.7144 3.56797 12.5714C3.63655 12.3657 3.68227 12.1599 3.75086 11.8399Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98525 6.81274C3.91079 6.81274 3.06494 6.17264 2.76775 5.16676C2.562 4.41235 2.51628 3.65794 2.67631 2.90354C2.92778 1.73763 3.86507 0.9375 4.98525 0.9375C6.1283 0.9375 7.20276 1.85193 7.45423 3.01784C7.61426 3.79511 7.54567 4.54952 7.24848 5.28107C6.85985 6.24122 6.01399 6.81274 4.98525 6.81274Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentShow);
export default __webpack_public_path__ + "static/media/content-show.28c83fdf3b86ad842e92132f7b6e00f6.svg";
export { ForwardRef as ReactComponent };